import React, { Component } from 'react';

import { getLocalHour, isMainHour } from "../utils/CommonUtil";
import { StatusGoodSmall } from 'grommet-icons';
class StatusIcon extends Component {

  render() {
    const { status, time, hadBadSample } = this.props;


    const localtime = getLocalHour(time);

    const pointStyle = {
      height: "41px"
    }

    const okColor = "#1aac60";
    const warnColor = "#ffc002";
    const errorColor = "#e5004c";
    const nodataColor = "#bdbec0";

    const bigok = (<StatusGoodSmall color={okColor} size="8px" style={pointStyle} />);
    const bigwarn = (<StatusGoodSmall color={warnColor} size="8px" style={pointStyle} />);
    const bigerror = (<StatusGoodSmall color={errorColor} size="8px" style={pointStyle} />);
    const bignodata = (<StatusGoodSmall color={nodataColor} size="8px" style={pointStyle} />);

    const smallok = (<StatusGoodSmall color={okColor} size="5px" style={pointStyle} />);
    // const smallwarn = (<StatusGoodSmall color={warnColor} size="9px" style={pointStyle} />);
    // const smallerror = (<StatusGoodSmall color={errorColor} size="9px" style={pointStyle} />);
    const smallnodata = (<StatusGoodSmall color={nodataColor} size="5px" style={pointStyle} />);

    let icon;
    switch (status) {
      case 'green':
        if (isMainHour(localtime)) {
          icon = bigok;
        } else {
          icon = smallok;
        }
        break;
      case 'red':
        icon = bigerror;
        break;
      case 'error':
        icon = bigerror;
        break;
      case 'nodata':
        if (isMainHour(localtime)) {
          icon = bignodata;
        } else {
          icon = smallnodata;
        }
        break;
      case 'yellow':
        if (isMainHour(localtime)) {
          icon = bigwarn;
        } else {
          icon = bigwarn;
        }
        break;
      default:
        icon = bignodata;
        break;
    }

    if (status === 'green' && hadBadSample) {
      const isMain = isMainHour(localtime);
      return (
        <span
          title="An interruption or outage occurred during this hour"
          aria-label="Green status; an interruption or outage occurred during this hour"
          role="img"
          style={{
            display: 'inline-flex',
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            width: isMain ? '8px' : '5px',
            height: '41px',
          }}
        >
          {icon}
          <span aria-hidden="true" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isMain ? '17px' : '13px',
            height: isMain ? '17px' : '13px',
            border: '2px solid #c47d00',
            borderRadius: '50%',
            boxSizing: 'border-box',
            pointerEvents: 'none',
          }} />
        </span>
      );
    }
    return icon;
  }
}

export default StatusIcon;